module.exports = __webpack_public_path__ + "static/media/bio_age_ris_ass_pla_saf.9337e0d4.png";